import React from "react";
import slugify from "../../utility/slugify";
import { Link } from "../link";

const InlineEntryHyperlink = ({
  node,
  className = "color-primary text-decoration-underline",
  children,
  references,
}) => {
  const { id } = node.data.target.sys;
  const ref = references?.find((el) => el?.contentful_id === id);
  if (ref?.product_tabs?.[0]?.layout_page) {
    const anchor = ref?.anchorTitle && "tab-" + slugify(ref?.anchorTitle);
    return (
      <Link className={className} to={`${ref?.product_tabs[0].layout_page[0]?.link}#${anchor}`}>
        {children}
      </Link>
    );
  } else if (ref?.link) {
    return (
      <Link className={className} to={ref.link}>
        {children}
      </Link>
    );
  } else if (ref?.anchorTitle) {
    return (
      <Link className={className} to={`#${slugify(ref.anchorTitle)}`}>
        {children}
      </Link>
    );
  } else {
    return null;
  }
};

export default InlineEntryHyperlink;
